import { sessionExpired } from '@/shared/auth'
import { Button } from '@/ui/button'
import { Drawer, DrawerCloseButton, DrawerContent } from '@/ui/drawer'
import { miniApp } from '@telegram-apps/sdk-react'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

export const SessionExpiredDrawer = () => {
  const { t } = useTranslation('app')
  const isOpen = sessionExpired.value

  // Закрытие drawer (кнопка X)
  const handleDismiss = useCallback(() => {
    sessionExpired.value = false
  }, [])

  // Перезапуск приложения (кнопка Restart App)
  const handleRestart = useCallback(() => {
    miniApp.close()
  }, [])

  return (
    <Drawer open={isOpen} dismissible={false} allowDialogMode={false}>
      <DrawerContent
        showGrabber={false}
        className="bg-white pt-6 pb-8 px-6 gap-12"
      >
        <DrawerCloseButton onClose={handleDismiss} />

        <div className="flex flex-col gap-4 items-center text-center">
          <h2 className="text-[32px] font-bold text-black tracking-[-0.64px] leading-normal">
            {t('session_expired_drawer.title')}
          </h2>
          <p className="text-[14px] font-medium text-[#6a6a6a] leading-[20px] max-w-[307px]">
            {t('session_expired_drawer.description')}
          </p>
        </div>

        <Button
          variant="tertiary"
          size="md"
          className="px-8 self-center"
          onClick={handleRestart}
        >
          {t('session_expired_drawer.restart_button')}
        </Button>
      </DrawerContent>
    </Drawer>
  )
}
